import { createContext, useContext } from "react";

export const ScrollRefContext = createContext(null);

export const useScrollRef = () => useContext(ScrollRefContext);
